import { createContext, useMemo, createElement, useContext } from 'react';

var Op = {
  OR: '$or',
  AND: '$and'
};
var NO_PROVIDER = '__toggled_no_provder_id__'; // @ts-ignore

var FeatureContext = /*#__PURE__*/createContext(NO_PROVIDER);
function createCache(features) {
  return features.reduce((cache, current) => {
    cache[current.slug] = current;
    return cache;
  }, {});
}
function createFlagQueryFn(cache) {
  return function flagQueryFn(flagQuery) {
    if (typeof flagQuery === 'string') {
      return Boolean(cache[flagQuery]);
    }

    if (Array.isArray(flagQuery)) {
      for (var query of flagQuery) {
        if (!flagQueryFn(query)) {
          return false;
        }
      }

      return true;
    }

    for (var key in flagQuery) {
      var phase = void 0;

      if (key === Op.OR) {
        phase = false; // @ts-expect-error

        for (var innerQuery of flagQuery[key]) {
          if (flagQueryFn(innerQuery)) {
            phase = true;
            break;
          }
        }
      } else if (key === Op.AND) {
        phase = true; // @ts-expect-error

        for (var _innerQuery of flagQuery[key]) {
          if (!flagQueryFn(_innerQuery)) {
            phase = false;
            break;
          }
        }
      } else {
        // @ts-expect-error
        phase = Boolean(cache[key]) === flagQuery[key];
      }

      if (!phase) {
        return false;
      }
    }

    return true;
  };
}
function FeatureProvider(props) {
  // @ts-expect-error
  var {
    features,
    cache,
    children
  } = props;
  var contextValue = useMemo(() => {
    var _cache = cache != null ? cache : createCache(features);

    return {
      cache: _cache,
      flagQueryFn: createFlagQueryFn(_cache)
    };
  }, [cache, features]);
  return createElement(FeatureContext.Provider, {
    value: contextValue
  }, children);
}

function useToggledContext() {
  var contextValue = useContext(FeatureContext); // @ts-ignore

  if (contextValue === NO_PROVIDER) {
    throw new Error('Component must be wrapped with FeatureProvider.');
  }

  return contextValue;
}

function useFeature(slug) {
  var {
    cache
  } = useToggledContext();
  return cache[slug];
}
function useFlagQueryFn() {
  var {
    flagQueryFn
  } = useToggledContext();
  return flagQueryFn;
}
function useFlag(flagQuery) {
  var flagQueryFn = useFlagQueryFn();
  return flagQueryFn(flagQuery);
}
function Flag(_ref) {
  var {
    flagQuery,
    children
  } = _ref;
  var enabled = useFlag(flagQuery);

  if (!enabled) {
    return null;
  }

  return children;
}
function Feature(_ref2) {
  var {
    slug,
    children
  } = _ref2;
  var feature = useFeature(slug);

  if (!feature) {
    return null;
  }

  return children(feature);
}

export { Feature, FeatureContext, FeatureProvider, Flag, Op, createCache, createFlagQueryFn, useFeature, useFlag, useFlagQueryFn };
//# sourceMappingURL=toggled.esm.js.map
